import { jsx as l } from "react/jsx-runtime";
const e = (c) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1rem",
    height: "1rem",
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "#FFC53D",
        fillRule: "evenodd",
        d: "M21.036 11.741a.56.56 0 0 0 0 .518l.777 1.526c.433.85.09 1.862-.78 2.306l-1.564.796a.59.59 0 0 0-.318.419l-.305 1.673c-.17.931-1.068 1.557-2.044 1.425l-1.753-.238a.63.63 0 0 0-.513.16l-1.273 1.18A1.85 1.85 0 0 1 12 22c-.455 0-.909-.164-1.263-.493l-1.272-1.181a.63.63 0 0 0-.514-.16l-1.753.238a2 2 0 0 1-.26.017c-.87 0-1.629-.594-1.784-1.442l-.305-1.673a.59.59 0 0 0-.318-.42l-1.563-.795c-.871-.444-1.214-1.456-.781-2.306l.777-1.526a.56.56 0 0 0 0-.518l-.777-1.526c-.433-.85-.09-1.862.78-2.305l1.564-.797a.59.59 0 0 0 .318-.419l.305-1.673c.17-.931 1.068-1.557 2.044-1.425l1.753.238a.63.63 0 0 0 .514-.16l1.272-1.18a1.864 1.864 0 0 1 2.526 0l1.273 1.18a.63.63 0 0 0 .513.16l1.753-.238c.975-.132 1.873.494 2.044 1.425l.305 1.673c.033.18.149.334.318.42l1.563.795c.871.444 1.214 1.456.781 2.306zM7.392 8.924c0-1.166.988-2.115 2.204-2.115 1.215 0 2.204.949 2.204 2.115s-.99 2.115-2.204 2.115c-1.216 0-2.204-.95-2.204-2.115m1.202 0c0 .53.45.961 1.002.961s1.001-.431 1.001-.961-.449-.961-1.001-.961c-.553 0-1.002.43-1.002.96m5.81 4.037c-1.215 0-2.204.949-2.204 2.115s.989 2.115 2.204 2.115 2.204-.949 2.204-2.115-.989-2.115-2.204-2.115m0 3.076c-.552 0-1.002-.43-1.002-.96s.45-.962 1.002-.962c.553 0 1.002.431 1.002.961s-.45.961-1.002.961m1.138-8.25a.62.62 0 0 1 .85 0 .56.56 0 0 1 0 .815l-7.934 7.613a.6.6 0 0 1-.425.169.6.6 0 0 1-.425-.17.56.56 0 0 1 0-.815z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  e as default
};
